import React, { useEffect, useState } from 'react'
import Gstate from "./StoreState/Gstate";
import Janani from "./Janani";
import { Routes, Route } from "react-router-dom";

function App() {

 return (
    <div >
      <Gstate>
        <Routes>
          <Route path="/" element={<Janani />} />
        </Routes>
      </Gstate>
    </div>
  )
}

export default App